import { ApplicationBookingState } from '@flatsy/types/Applications'
import React from 'react'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import { useMobile } from 'src/hooks/Mobile'
import BookingOverview from './Overview'
import BookingOverviewMobile from './Overview/Mobile'
import BookingSelection from './Selection'

const Booking: React.FC = (): React.ReactElement => {
  const { application } = useApplicationDetails()
  const isMobile = useMobile()

  const showBookingSelector = (): boolean => {
    if (application.application.booking_state === ApplicationBookingState.AUTHORIZED) {
      return true
    }

    return false
  }

  if (showBookingSelector()) {
    return <BookingSelection />
  }
  if (isMobile) {
    return <BookingOverviewMobile />
  }
  return <BookingOverview />
}

export default Booking
